import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import { cn } from './cn';

/**
 * Field — label + control + helper/error wrapper.
 * Use for any form field to enforce consistent vertical rhythm and messaging.
 *
 *   <Field label="Email" required error={errors?.email?.message} hint="We'll never share.">
 *     <Input {...register('email')} invalid={!!errors?.email} />
 *   </Field>
 */
export function Field({
  label,
  required,
  hint,
  error,
  id,
  className,
  children,
  secondaryLabel,
}) {
  return (
    <div className={cn('flex flex-col gap-1.5', className)}>
      {(label || secondaryLabel) && (
        <div className="flex items-baseline justify-between">
          {label && (
            <label htmlFor={id} className="text-caption text-fg-muted">
              {label}
              {required && <span className="text-danger-600 dark:text-danger-500"> *</span>}
            </label>
          )}
          {secondaryLabel && (
            <span className="text-caption text-fg-subtle">{secondaryLabel}</span>
          )}
        </div>
      )}
      {children}
      {error ? (
        <p className="inline-flex items-center gap-1 text-caption font-medium text-danger-600 dark:text-danger-500">
          <FiAlertCircle size={12} aria-hidden />
          {error}
        </p>
      ) : hint ? (
        <p className="text-caption text-fg-subtle">{hint}</p>
      ) : null}
    </div>
  );
}

export default Field;
